<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: 0.35s height;
}
</style>
<template>
  <div>
    <div>
      <b-form ref="form" @change="formChanged()" class="repeater-form" v-if="JobCard">
        <!-- Row Loop -->
        <b-row v-for="(item, index) in JobCard.bom" :id="index.toString()" :key="index" ref="row" v-b-tooltip.hover
        title="Once a purchase order has been created you cannot modify any information except status!">
          <!-- Item Name -->
          <b-col md="2">
            <b-form-input id="cost" placeholder="" v-model="item.materialId" hidden/>
            <b-form-group label="Raw Material / Work In Progress" label-for="Operation-name" >
              <b-form-input id="cost" placeholder="" v-model="item.rawMaterial" disabled/>
              {{ new Date(item.createdOn).toLocaleDateString("fr-FR")}}
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="Status" label-for="Status">
              <b-form-select v-model="item.status" :options="BOMStatusList" @change="callChangeStatus(item)" /> 
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group label="Warehouse" label-for="Warehouse">
               <b-form-select v-model="item.wareHouseId" :options="optionsWarehouse" @change="updateQtyAtHand(item)"/>
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="UOM" label-for="cost">
              <b-form-input id="cost" placeholder="" v-model="item.uom" disabled/>
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="Qty at hand" label-for="materialQtyAtHand">
              <b-form-input v-model="item.physicalinventory" step="0.00001" id="materialQtyAtHand" name="materialQtyAtHand" ref="qtyAtHandInput"
                readonly/>
            </b-form-group>
          </b-col>
          <b-col md="1">
            <b-form-group label="Qty Required" label-for="cost">
              <b-form-input id="cost" type="number" placeholder="" :value="item.quantity"
              step="0.00001" @change="itemChanged(item, $event)" readonly/>
            </b-form-group>
          </b-col>
          <!-- Profession -->
          <b-col lg="1" md="1">
            <b-form-group label="Total Cost" label-for="price">
              <b-form-input v-if="HasPermission(PermissionList.Production_Finance)" id="pzrice" value="32$" v-model="item.totalCost" disabled />
            </b-form-group>
          </b-col>
          <b-col lg="1" md="1" class="mr-2">
              <b-button variant="primary" class="mt-0 mt-md-2 mr-6" @click="handleDocumentBtn(item.materialId)">
              <span>View Document</span>
            </b-button> 
          </b-col>

          <!-- Remove Button -->
          <b-col lg="1" md="2">
            <b-button v-ripple.400="'rgba(234, 84, 85, 0.15)'" variant="outline-danger" class="mt-2 mt-md-2 mr-3" 
            @click="removeItem(index, item.id)">
              <feather-icon icon="XIcon"  />
            </b-button> 
          </b-col>

     
          <b-col md="1" class="mb-0 d-flex align-items-center">
            <b-form-checkbox
            :value="item.itemId" @change="AddBOMPO(item)"
            class="mb-0">
          </b-form-checkbox>
          </b-col>

          <!-- <b-col md="1" class="mb-0 d-flex align-items-center">
            <b-form-checkbox
            :value="item.itemId" @change="AddBOMPO(item)"
            class="mb-0">
          </b-form-checkbox>
          </b-col> -->
          <!-- <b-col lg="2" md="1" class="mb-50">
            <b-button variant="primary" class="mt-0 mt-md-2" :to="createPurchase(item.materialId, (item.quantity - item.physicalInventory))">
              <feather-icon icon="XIcon" class="mr-25" />
              <span>Create PO</span>
            </b-button>
          </b-col> -->
          <b-col cols="12">
            <hr />
          </b-col>
        </b-row>
      </b-form>
      <!-- <div :class="isVisible ? 'd-flex justify-content-end' : 'd-none justify-content-end'">
        <b-button variant="primary" class="mt-0 mt-md-2 mr-3" @click="createPurchase()">
          <feather-icon icon="XIcon" class="mr-25" />
          <span>Create PO</span>
        </b-button> 
      </div> -->
    </div>

<!-- Document Modal -->
 
<b-modal ref="modal-view-raw-material-document" id="modal-view-raw-material-document" ok-only ok-title="View" centered size="lg" title="View Raw Material Documents" :hide-footer="true">
<DocumentUpload
  @downloadFile="downloadFile"
  :documentDetails="documentDetails"
  :viewOnly="true"
/>
</b-modal>
<!-- Document Modal -->

  </div>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BFormSelect,
  BFormTextarea,
  BFormCheckbox,
  BCard,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import DocumentUpload from "@/views/component/DocumentUpload.vue";
import { PermissionList } from "@/libs/defaultList";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
export default {
  components: {
    BForm,
    BRow,
    BCard,
    vSelect,
    BCol,
    BButton,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormSelect,
    DocumentUpload,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      id: this.$route.params.id,
      selectedBom: null,
      nextTodoId: 2,
      isVisible: false, // Initial state
      selectedBOMItems: [],
      removedBom: [],
      optionsWarehouse: [],
      item: {
        physicalInventory: 0, // Example initial value
      },
      BOMStatusList: [
        // { value: null, text: "Select Status" },
        { value: 0, text: "Requested with store" },
        { value: 1, text: "Awaiting delivery from supplier" },
        { value: 2, text: "Received" },
        { value: 3, text: "OnHold" }
      ],
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  props: {
    JobCard: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    return {
      PermissionList,
      HasPermission,
    };
  },

  beforeMount() {
    this.getWarehouseListAction();
  },

  async mounted() {
    if (this.warehouse == undefined || this.warehouse.length == 0)
    await this.getWarehouseListAction();
    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );

    this.onQtyAtHandLoad();

    // this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);
    // await this.getWarehouseAction(this.JobCard.wareHouseId);

  },
  methods: {

    ...mapActions("rawmaterialModule", ["getRawMaterialListByIdAction", "getRawMaterialDocumentListAction", "downloadRawMaterialDocumentAction"]),
    ...mapActions("warehouseModule", ["getWarehouseAction"]),
    callChangeStatus(item) {
      console.log('item.status', item.status)
      this.$emit("status", item.status);
    },


    updateQtyAtHand(item) {

      // Find the selected warehouse
      const selectedWarehouse = this.warehouse.find(
        (wh) => wh.id === item.wareHouseId
      );
      console.log("test🫡", selectedWarehouse);
      if (!selectedWarehouse) {
        console.error("Selected warehouse not found");
        return;
      }
      // Find the item in the warehouse's itemBalance

      const itemInWarehouse = selectedWarehouse.itemBalance.find(
        (ib) => ib.productId === item.materialId
      );
      console.log("test2🫡", item.materialId);
      console.log("test3🫡", itemInWarehouse);

        // Set item.physicalInventory to 0 if itemInWarehouse is undefined or null
    item.physicalinventory = itemInWarehouse ? itemInWarehouse.stockLevel : 0;

    // Optional: Log a message if the item is not found in the warehouse
    if (!itemInWarehouse) {
      console.warn(`Item with materialId ${item.materialId} not found in warehouse ${selectedWarehouse.name}. Setting physicalInventory to 0.`);
    }

    },

    AddBOMPO(item){
      const index = this.selectedBOMItems.findIndex(selectedItem => selectedItem.id === item.materialId);

      if (index === -1) {
          // If item not in the list, add it
          this.selectedBOMItems.push({ id: item.materialId, quantity: (item.quantity < item.physicalinventory ? 1 : item.quantity - item.physicalinventory) });
      } else {
        // If item is already selected, remove it
        this.selectedBOMItems.splice(index, 1);
      }

      this.$emit('existingPO', this.selectedBOMItems);

    },

    onQtyAtHandLoad() {
      // Access the input element using the ref
      const inputElement = this.$refs.qtyAtHandInput;
      if (inputElement) {
        this.updateQtyAtHand();
      }
    },
    updateQtyAtHand() {
      if (this.JobCard && this.JobCard.bom) {
      this.JobCard.bom.forEach(item => {
        const selectedWarehouse = this.warehouse.find(
          wh => wh.id === item.wareHouseId
        );
        
        if (selectedWarehouse) {
          const itemInWarehouse = selectedWarehouse.itemBalance.find(
            ib => ib.productId === item.materialId
          );
          item.physicalinventory = itemInWarehouse?.stockLevel || 0;
        } else {
          item.physicalinventory = 0; // Default if warehouse not found
        }
      });
    }
    },

    async createPurchase() {
      // Map the ids of the selected BOM items and join them with commas
      
      const itemIds = this.selectedBOMItems.map(item => `${item.id}_${item.quantity}`).join(',');
      try {
        // Redirect to the add purchase order page with selected item IDs in the path
        //const itemIds = this.selectedItemIds.join(",");

        if(itemIds == "" || itemIds.includes('null_1'))
        {
          this.$swal({
          title: "No items",
          text: "Please select at least 1 item to initiate purchase order",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });

          return;
        }
        this.$router.push({
          name: "purchaseorder-add",
          query: { itemIds: itemIds },
        });
      } catch (error) {
        this.$swal({
          title: "Error!",
          text: "There was an error navigating to the Purchase Order creation page.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      }
    },
    // createPurchase(id, quantity) {
    //   return "/purchaseorders/add/" + id + "/" + quantity;
    // },
    repeateAgain() {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
      });
 
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index, id) {
         // Remove the item from selectedBOMItems
         this.selectedBOMItems.splice(index, 1);
  
        // Emit the updated list
        this.$emit('existingPO', this.selectedBOMItems);

      let removedItemCost = this.JobCard.bom[index].totalCost || 0;
      this.JobCard.bom.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
      this.removedBom.push(id);
      this.JobCard.actualCost -= removedItemCost;
      console.log(this.JobCard)
      this.formChanged();
    },
    initTrHeight() {
      this.trSetHeight(null);
      if (this.$refs.form) {
        this.$nextTick(() => {
          this.trSetHeight(this.$refs.form.scrollHeight);
        });
      }
    },
    itemChanged: function (item, newVal) {
      let oldQty = item.quantity;
      let newQty = newVal;
      let unitCost = item.totalCost / oldQty;
      let oldTotalCost = item.totalCost; // Save the old total cost before updating

      item.quantity = newQty;
      item.totalCost = item.quantity * unitCost;
      item.Status = item.Status;
      let differenceInTotalCost = item.totalCost - oldTotalCost; // Calculate the difference in total cost
      this.JobCard.actualCost += differenceInTotalCost; // Apply the difference to the actual cost

      console.log(this.JobCard.actualCost);
    },
    formChanged() {
      this.$emit("onchange", this.removedBom);
    },
    async handleDocumentBtn(rawMaterialId) {
      try {
        await this.getRawMaterialDocumentListAction(rawMaterialId);
        if (this.documents.length > 0) {
          this.documentDetails.documentList = this.documents;
          this.documentDetails.isDelete = false;
        }
        this.$refs["modal-view-raw-material-document"].show();
      } catch (error) {
        console.error("Error fetching documents:", error);
      }
    },

    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: 'Processing...',
        text: 'Please wait while the document is being prepared for download',
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await this.downloadRawMaterialDocumentAction(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream',
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error('Download failed:', error);
        loader.close();
        this.error('Failed to download the file. Please try again.'); // Updated error message for better clarity
      }
    },
  },
  computed:{
    
    ...mapGetters("rawmaterialModule", {
      rawmaterialsID: "rawmaterialsID",
      loading: "loading",
      documents: "documents",
      file: "file",
    }),

    ...mapGetters("warehouseModule", {
            wareHouseId: "warehouseId",
            loading: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
  }
};
</script>
